import { render, staticRenderFns } from "./EmbeddedEditMenuContainer.vue?vue&type=template&id=28f0be90&scoped=true&"
import script from "./EmbeddedEditMenuContainer.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedEditMenuContainer.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedEditMenuContainer.vue?vue&type=style&index=0&id=28f0be90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0be90",
  null
  
)

export default component.exports